
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../src/Icon.js";
    
    const symbol = new SpriteSymbol({
  "id": "socio",
  "use": "socio-usage",
  "viewBox": "0 0 91.333 85.167",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 91.333 85.167\" id=\"socio\"><g fill=\"none\"><circle cx=\"53.283\" cy=\"20.375\" r=\"7.495\" /><path d=\"M49.538 41.688l-4.469-9.769a8.352 8.352 0 00-5.637 7.898v11.19c0 4.609 3.738 5.501 8.348 5.501h11.002c4.613 0 8.352-.892 8.352-5.501v-11.19a8.35 8.35 0 00-5.637-7.898l-4.469 9.769\" /><path d=\"M53.831 48.669l3.197-6.98-2.25-4.916a2.668 2.668 0 001.162-2.194 2.658 2.658 0 10-5.314 0c0 .909.457 1.714 1.164 2.194l-2.252 4.916 3.193 6.98c.305.667.799.667 1.1 0zM37.979 19.876h-4.715v-4.715a2.142 2.142 0 10-4.286 0v4.715h-4.715a2.143 2.143 0 000 4.286h4.715v4.715a2.144 2.144 0 004.286 0v-4.715h4.715a2.142 2.142 0 100-4.286z\" /></g></symbol>"
});
    sprite.add(symbol);

    export default class SocioSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="socio" {...this.props} />;
      }
    }
  